import React from 'react';
import { Wifi, Tv, Coffee, Clock, MapPin, Sparkles, Leaf, Users } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Wifi,
      title: 'WiFi en áreas comunes',
      description: 'Contamos con conexión inalámbrica en todos nuestros espacios compartidos para su comodidad.'
    },
    {
      icon: Tv,
      title: 'TV Cable',
      description: 'Todas las habitaciones cuentan con televisión por cable.'
    },
    {
      icon: Coffee,
      title: 'Comedor',
      description: 'Desayuno continental incluido 08:00 - 10:00 am hrs'
    },
    {
      icon: Sparkles,
      title: 'Servicio de mucama',
      description: 'Limpieza y mantenimiento diario de habitaciones para garantizar su comodidad.'
    },
    {
      icon: Leaf,
      title: 'Áreas Verdes',
      description: 'Espacios naturales para relajarse.'
    },
    {
      icon: Users,
      title: 'Espacios Comunes',
      description: 'Áreas de convivencia amplias.'
    },
    {
      icon: MapPin,
      title: 'Excelente Ubicación',
      description: 'En pleno centro de la ciudad, cercano a supermercados y bancos.'
    },
    {
      icon: Clock,
      title: 'Atención Personalizada',
      description: 'Personal capacitado y certificado para satisfacer sus necesidades.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Contamos con toda la infraestructura necesaria para su confort y tranquilidad
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-800 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                  <Icon className="w-8 h-8 text-amber-400" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
